import React from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import NewTabLink from './NewTabLink';
import { getItemById } from '../../utils';

const StyledItem = styled.div`
  line-height: 24px;
  cursor: pointer;
  box-shadow: 0 1px 1px 1px rgba(10, 16, 34, 0.08);
  border-radius: 5px;
  background: white;
  transition: transform 0.2s ease, box-shadow 0.2s ease, -webkit-transform 0.2s ease,
    -webkit-box-shadow 0.2s ease;
  will-change: transform, box-shadow;

  &:hover {
    box-shadow: 0 16px 32px 0 rgba(10, 16, 34, 0.2), 0 0 0 transparent;
    transform: translateY(-5px) translateZ(0);
  }
`;

const TextInfo = styled.div`
  padding: 16px;
  padding-top: 24px;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const PrimaryLine = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

const SecondaryLine = styled.div`
  color: #888
  font-size: ${props => props.theme.font.small}px;
`;

const CompanyImageParent = styled.div`
  width: 100%;
  padding-top: 70%;
  min-width: 33%;
  position: relative;
`;

export const CompanyImage = styled.div`
  background-image: url(${props => props.bgSrc});
  background-position: center center;
  background-size: cover;
  border-bottom: solid 1px #f1f1f1;
  border-radius: 6px 6px 0 0;

  background-image: url(${props => props.bgSrc});
  background-position: center center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const HiringButton = styled(NewTabLink)`
  border-radius: 4px;
  display: table;
  font-size: ${props => props.theme.font.small}px;
  font-weight: bold;
  color: #30e849;
  border: 1px solid #30e849;
  cursor: pointer;
  padding: 0 12px;
  opacity: 1;
`;

const PrimaryLineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ProjectItem = ({ setModal, index, setStartupIndex, history, projectId, ...other }) => {
  const project = getItemById(projectId);

  if (!project) {
    return null;
  }
  const { product, company } = project;

  const handleClick = () => {
    setModal(true);
    setStartupIndex(index);
    history.push(`?projectId=${projectId}`);
  };
  return (
    <StyledItem onClick={handleClick} {...other}>
      <CompanyImageParent>
        <CompanyImage bgSrc={product.images.macbookMock} />
      </CompanyImageParent>
      <TextInfo>
        <PrimaryLineWrapper>
          <PrimaryLine>{product.title}</PrimaryLine>
          {company.hiringUrl && <HiringButton>Kariéra</HiringButton>}
        </PrimaryLineWrapper>
        <SecondaryLine>{product.description}</SecondaryLine>
      </TextInfo>
    </StyledItem>
  );
};

export default withRouter(ProjectItem);
